import React from "react";
import "./HeroHeader.css";
import heroVideo from "./hero.mp4";

const HeroHeader = () => {
  return (
    <section className="hero-header">
      {/* Background Video */}
      <video className="bg-video" autoPlay muted loop>
        <source src={heroVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="overlay"></div>

      {/* Text Content */}
      <div className="text-content">
        <h2>Escape to Paradise</h2>
        <p>
          Unveil the most enchanting shores, where azure waters embrace powdery
          sands. From secluded coves to vibrant coastlines, find the perfect
          spot to unwind and explore.
          <br />
        </p>
        <a href="./tours">
          <button className="btn-tours">Find Your Dream Tour</button>
        </a>
      </div>

      {/* Facebook Button */}
      <a
        href="https://www.facebook.com/TwinTravelcoron2019"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-facebook"
      >
        Facebook
      </a>
    </section>
  );
};

export default HeroHeader;
